module.exports = __webpack_public_path__ + "img/architecturalart_bodyimage02.7fe53d42.png";